<template>
  <section class="home_sec sec0">
    <h3><span>휴대폰을 잃어버렸나요?</span>MFINDER로 빠르고 쉽게 찾아보세요</h3>
    <div class="home_wrap">
      <div class="find">
        <button type="button" class="find_btn" @click="goIntro"><i class="arrow"></i>자세히 보기</button>
      </div>
      <swiper class="sec0_slide" :options="swiperOption">
        <div class="swiper-pagination" slot="pagination"></div>
        <swiper-slide>
          <div class="slide_wrap home_desc">
            <strong class="tit">분실폰의 회수를 위한<br />다양한 기능을 사용해보세요.</strong>
            <p>
              하루 가장 많은 시간을 나와 함께하는 휴대폰을 잃어버렸다면? MFINDER가 제공하는<br />
              다양한 기능들을 통해 빠르고 쉽게 찾아보세요.
            </p>
          </div>
          <span class="img"><img src="@/assets/images/sec0_slide3.png" alt="" /></span>
        </swiper-slide>
        <swiper-slide>
          <div class="slide_wrap home_desc">
            <strong class="tit">분실폰의 위치와 실시간 주변 <br />환경을 확인할 수 있습니다</strong>
            <p>
              [분실폰 찾기]에 접속하여 분실 휴대폰의 카메라와 마이크를 실행하세요. 카메라의<br />
              전, 후면을 통해 실시간으로 주변 상황과 위치를 확인하고, 음성을 통해 회수 요청을<br />해보세요.
            </p>
          </div>
          <span class="img"><img src="@/assets/images/sec0_slide0.png" alt="" /></span>
        </swiper-slide>
        <swiper-slide>
          <div class="slide_wrap home_desc">
            <strong class="tit">분실폰의 스피커를 통해 회수요청<br />음성 메시지를 전달할 수 있습니다.</strong>
            <p>
              [분실폰 찾기]에 접속하여 분실 휴대폰의 스피커로 음성 메시지를 전달 해보세요.<br />
              무음모드로 설정되어 있어도 최대 볼륨으로 회수요청 메시지를 전달할 수 있습니다.
            </p>
          </div>
          <span class="img"><img src="@/assets/images/sec0_slide1.png" alt="" /></span>
        </swiper-slide>
        <swiper-slide>
          <div class="slide_wrap home_desc">
            <strong class="tit">분실폰의 데이터를 백업하고<br />개인정보는 안전하게 삭제해보세요.</strong>
            <p>
              [분실폰 찾기]에 접속하여 휴대폰에 저장된 사진과 동영상, 연락처 등을 신속<br />하게 백업해 보세요. 이
              데이터들은 복원이 가능합니다. 또 민감한 개인정보<br />는 백업 후 안전하게 삭제하세요.
            </p>
          </div>
          <span class="img"><img src="@/assets/images/sec0_slide2.png" alt="" /></span>
        </swiper-slide>
      </swiper>
    </div>
  </section>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper"
import "swiper/css/swiper.css"

export default {
  name: "HomeSection0",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      swiperOption: {
        loop: true,
        speed: 500,
        slidesPerView: "1",
        centeredSlides: true,
        autoplay: {
          delay: 4700,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
    }
  },
  methods: {
    goIntro() {
      this.$router.push("/intro")
    },
  },
}
</script>
